import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ObjectKeyCount',
    standalone: false
})
export class ObjectKeyCountPipe implements PipeTransform {
  transform(value: any): number {
    return value ? Object.keys(value).length : 0;
  }
}
